export enum PackageTypeCondition {
  DAMAGED = 'Damaged',
  NOT_DAMAGED = 'Not Damaged',
}
